/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllCampaigns = async (
    clientId?: number,
    includeTestData?: number,
    pageNumber?: number,
    perPage?: number,
    typeId?: number,
    campaignId?: number,
    campaignName?: string,
    brandId?: number,
    groupId?: number,
    status?: number,
    mode?: string
) => {
    const params = new URLSearchParams();

    // Explicitly handle null, undefined, 0, and NaN cases
    if (clientId != null && !isNaN(clientId) && clientId !== 0) {
        params.append('clientId', clientId.toString());
    }
    if (includeTestData === 1) {
        params.append('includeTestData', '1');
    }
    if (pageNumber != null) {
        params.append('pageNumber', pageNumber.toString());
    }
    if (perPage != null) {
        params.append('perPage', perPage.toString());
    }
    if (typeId != null) {
        params.append('typeId', typeId.toString());
    }
    if (campaignId != null) {
        params.append('campaignId', campaignId.toString());
    }
    if (campaignName != null && campaignName.trim() !== '') {
        params.append('campaignName', campaignName.trim());
    }
    if (brandId != null) {
        params.append('brandId', brandId.toString());
    }
    if (groupId != null) {
        params.append('groupId', groupId.toString());
    }
    if (status != null) {
        params.append('status', status.toString());
    }
    if (mode != null && mode.trim() !== '') {
        params.append('mode', mode.trim());
    }

    let url = '/campaign/all';
    const queryString = params.toString();
    if (queryString) {
        url += `?${queryString}`;
    }

    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignDetailsById = async (campaignId: number) => {
    const response = await http.get(`/campaign/${campaignId}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const addNewCampaign = async (data: any) => {
    const response = await http.post(`/campaign/add`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateNewCampaign = async (data: any) => {
    const response = await http.put(`/campaign/update`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const deleteCampaign = async (data: any) => {
    const response = await http.delete(`/campaign/delete`, { data: data });
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const changeStatusCampaign = async (data: any) => {
    const response = await http.post(`/campaign/active`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const copyCampaign = async (data: any) => {
    const response = await http.post(`/campaign/copy`, data); // Directly pass data without wrapping in 'data'
    return response;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportData = async (campaignId: any, fromDate?: any, toDate?: any, statusId?: any, type?: any, includeTestData?: number) => {
    let response;
    const testDataParam = includeTestData === 1 ? `&includeTestData=1` : '';
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if(fromDate && toDate) {

        if(type === 'bulkemail') {
            response = await http.get(`/campaign/Report/Download/${campaignId}?fromDate=${fromDate}&toDate=${toDate}&statusId=${statusId}&type=${type}${testDataParam}`);
        } else {
            response = await http.get(`/campaign/Report/Download/${campaignId}?fromDate=${fromDate}&toDate=${toDate}&statusId=${statusId}${testDataParam}`);
        }

        return response;
    }
    if(type === 'bulkemail') {
        response = await http.get(`/campaign/Report/Download/${campaignId}?type=${type}${testDataParam}`);
    } else {
        response = await http.get(`/campaign/Report/Download/${campaignId}${testDataParam ? `?includeTestData=1` : ''}`);
    }

    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateCampaignTestMode = async (data: any) => {
    const response = await http.post(`/campaign/changetestmode`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportCardCounts = async (campaignId: any, clientId: any, startDate: any, endDate: any, status: any, type: any, includeTestDatavalue?: number) => {

    const params = new URLSearchParams();
    params.append('clientId', clientId);
    params.append('campaignId', campaignId);
    params.append('status', status);
    if(type) {
        params.append('type', type);
    }

    if(type && type === 'listtrigger') {
        params.append('listTriggerId', campaignId);
    }
    // Only add dates if both exist
    if (startDate && endDate) {
        params.append('fromDate', startDate);
        params.append('toDate', endDate);
    }
    // Only add includeTestData parameter if value is 1
    if (includeTestDatavalue === 1) {
        params.append('includeTestData', '1');
    }
  const response = await http.get(`/campaign/dashboard/cardcounts?${params.toString()}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportDomainCount = async (campaignId: any, clientId: any, startDate: any, endDate: any, status: any, type: any, includeTestDatavalue?: number, heatmapEventFilter?: any) => {
     const params = new URLSearchParams();
        params.append('clientId', clientId);
        params.append('campaignId', campaignId);
        params.append('status', status);
        if(type) {
            params.append('type', type);
        }
        if(type && type === 'listtrigger') {
            params.append('listTriggerId', campaignId);
        }
        // Only add dates if both exist
        if (startDate && endDate) {
        params.append('fromDate', startDate);
        params.append('toDate', endDate);
        }
        // Only add includeTestData parameter if value is 1
        if (includeTestDatavalue === 1) {
            params.append('includeTestData', '1');
        }
         if(heatmapEventFilter) {
            params.append('heatmapEventFilter', heatmapEventFilter);
        }
    const response = await http.get(`/campaign/dashboard/domaincounts?${params.toString()}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportHeatmapCount = async (campaignId: any, clientId: any, startDate: any, endDate: any, status: any, type: any, heatmapEventFilter: any, includeTestDatavalue?: number) => {
    const params = new URLSearchParams();
       params.append('clientId', clientId);
       params.append('campaignId', campaignId);
       params.append('status', status);
       params.append('heatmapEventFilter', heatmapEventFilter);
       if(type) {
           params.append('type', type);
       }
       if(type && type === 'listtrigger') {
           params.append('listTriggerId', campaignId);
       }
       // Only add dates if both exist
       if (startDate && endDate) {
       params.append('fromDate', startDate);
       params.append('toDate', endDate);
       }
       // Only add includeTestData parameter if value is 1
       if (includeTestDatavalue === 1) {
           params.append('includeTestData', '1');
       }
   const response = await http.get(`/campaign/dashboard/heatmapcounts?${params.toString()}`);
   return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportDeviceCount = async (campaignId: any, clientId: any, startDate: any, endDate: any, status: any, type: any, includeTestDatavalue?: number) => {
     const params = new URLSearchParams();
        params.append('clientId', clientId);
        params.append('campaignId', campaignId);
        params.append('status', status);
        if(type) {
            params.append('type', type);
        }
        if(type && type === 'listtrigger') {
            params.append('listTriggerId', campaignId);
        }
        // Only add dates if both exist
        if (startDate && endDate) {
        params.append('fromDate', startDate);
        params.append('toDate', endDate);
        }
        // Only add includeTestData parameter if value is 1
        if (includeTestDatavalue === 1) {
            params.append('includeTestData', '1');
        }
    const response = await http.get(`/campaign/dashboard/devicecounts?${params.toString()}`);
    return response;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getResendStatus = async (campaignId?: any, listTriggerId?: any, type?: any) => {
    const queryParams = [];

    if (campaignId) queryParams.push(`id=${campaignId}`);
    if (listTriggerId) queryParams.push(`id=${listTriggerId}`);

    const campaignTypeMap: Record<string, string> = { bulkemail: "BulkCampaign", listtrigger: "ListTrigger" };
    const resolvedType = type ? (campaignTypeMap[type as string] ?? type as string) : "TriggerCampaign";
    queryParams.push(`campaignType=${resolvedType}`);

    const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

    const response = await http.get(`/campaign/getresendstatus${queryString}`);
    return response;
};

//Export Custom Report
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCustomFieldData = async () => {
    const response = await http.get(`/report/getcustomnpifields`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const exportCustomFieldReport = async (data: any, type?: any) => {
    if(type === 'bulkemail') {
        const response = await http.post(`/report/customnpireportcampaign?type=${type}`, data);
        return response;
    }
    const response = await http.post(`/report/customnpireportcampaign`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const exportStandardReport = async (campaignId: any, type?: any) => {
    if(type === 'bulkemail') {
        const response = await http.get(`/report/standardnpireportcampaign/${campaignId}?type=${type}`);
        return response;
    }
    const response = await http.get(`/report/standardnpireportcampaign/${campaignId}`);
    return response;
}


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getCampaignReportCategoryCount = async (
  campaignId: any,
  clientId: any,
  startDate: any,
  endDate: any,
  status: any,
  type: any,
  includeTestDatavalue?: number
) => {
  const params = new URLSearchParams();

  params.append('clientId', clientId);
  params.append('campaignId', campaignId);
  params.append('status', status);
  if(type) {
        params.append('type', type);
    }
    if(type && type === 'listtrigger') {
        params.append('listTriggerId', campaignId);
    }
  // Only add dates if both exist
    if (startDate && endDate) {
        params.append('fromDate', startDate);
        params.append('toDate', endDate);
    }
  // Only add includeTestData parameter if value is 1
  if (includeTestDatavalue === 1) {
      params.append('includeTestData', '1');
  }

  const response = await http.get(`/campaign/dashboard/categorycounts?${params.toString()}`);
  return response;
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllBulkCampaigns = async (clientId?: number) => {
    // Explicitly handle null, undefined, 0, and NaN cases
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/bulkcampaign/all?clientId=${clientId}` : '/bulkcampaign/all';
    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}